import { render, staticRenderFns } from "./ed-class-subject-placeholder-to-block-modal.component.vue?vue&type=template&id=89feee60&scoped=true&"
import script from "./ed-class-subject-placeholder-to-block-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-subject-placeholder-to-block-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-subject-placeholder-to-block-modal.component.scss?vue&type=style&index=0&id=89feee60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89feee60",
  null
  
)

export default component.exports